module.exports = "/assets/19f2ad7dc71c8df5e43ad8887ad669da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/small/hotel.png
// module id = 3543
// module chunks = 0